import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import DateAdapter from "@mui/lab/AdapterMoment";
import { LocalizationProvider, TimePicker } from "@mui/lab";
import FieldContainer from "../form-component/container/FieldContainer";

const FormikTimeField = (props) => {
  const pr = props.formik;

  const handleChange = (e) => {
    pr.setFieldValue(props.fieldName, e)
  }

  return(
    <FieldContainer {...props} >
      <LocalizationProvider dateAdapter={DateAdapter}>
        <TimePicker
          {...props}
          size="small"
          value={pr.values && pr.values[props.fieldName]}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} variant={'outlined'} fullWidth={true} error={Boolean(pr.errors[props.fieldName])} helperText={pr.errors[props.fieldName]} />}
        />
      </LocalizationProvider>
    </FieldContainer>
  )
}

FormikTimeField.defaultProps ={

}
FormikTimeField.propTypes ={
  fieldName: PropTypes.string,
  formik: PropTypes.any
}

export default FormikTimeField;
